module.exports = __webpack_public_path__ + "static/media/andzoa.6eb5eef8.webp";